import { gql } from '@apollo/client'

import { TaskFragment } from './task.fragment'

export const PlanningFragment = gql`
  fragment PlanningFragment on Planning {
    id
    createdDate
    updatedDate
    tasks {
      ...TaskFragment
    }
  }
  ${TaskFragment}
`
